<template>
  <tr>
    <td
      class="koumoku claimCont cwC_1"
      :class="{ overLengthFrame: isOverLength() }"
    >
      <input
        type="text"
        class=""
        :class="{ overLength: isOverLength() }"
        :disabled="btnDisable"
        v-model="item.c_claim_det_item"
      />
      <div
        class="icon-stack icon-stack-lg"
        :class="{ overLengthIcon: isOverLength() }"
        style="display: none; color: red; font-size: 12px"
      >
        <i
          class="fal fa-info-circle"
          style="font-size: 16px; margin-right: 5px"
        ></i
        >全角23文字を超えた場合、文字数に応じて表示サイズが縮小されます。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;視認性が低下する可能性がありますので、ご注意ください。
      </div>
    </td>
    <td class="suuryou claimCont cwC_2">
      <input
        type="text"
        style="text-align: right; background: none"
        class=""
        :disabled="btnDisable"
        v-model="item.c_claim_det_quantity"
      />
    </td>
    <td class="suuryou claimCont cwC_2">
      <input
        type="text"
        style="text-align: right"
        class=""
        :disabled="btnDisable"
        v-model="item.c_claim_unit_symbol"
      />
    </td>
    <td class="tanka claimCont cwC_3">
      <input
        type="text"
        style="text-align: right"
        class=""
        :disabled="btnDisable"
        v-model="item.c_claim_det_unitprice"
      />
    </td>
    <td class="kingaku claimCont cwC_4">
      <input
        type="text"
        style="text-align: right"
        maxlength="50"
        class=""
        :disabled="btnDisable"
        @focus="kanmaDel($event)"
        @blur="kanmaIns($event)"
        @change="calcTax()"
        v-model="item.c_claim_det_price"
      />
    </td>
    <td
      class="syouhizei claimCont cwC_5 selectedClear selectBorderNone disableWhite"
    >
      <vSelect
        :disabled="btnDisable"
        :selectable="calcTax()"
        :options="opTaxtate"
        v-model="item.c_claim_det_taxrate"
        :reduce="(label:any) => label.code"
      ></vSelect>
    </td>
    <td class="zeikomi claimCont cwC_6">
      <input
        type="text"
        style="text-align: right"
        class=""
        disabled="true"
        v-model="item.c_claim_det_price_sum"
      />
    </td>
    <td class="keisan claimCont cwC_7 selectBorderNone disableWhite">
      <vSelect
        :disabled="btnDisable"
        :options="opRouding"
        v-model="item.c_claim_det_rounding"
        :reduce="(label:any) => label.code"
      ></vSelect>
    </td>
    <td class="zeikomi claimCont cwC_8">
      <input
        type="text"
        style="text-align: left"
        :disabled="btnDisable"
        class=""
        v-model="item.c_claim_det_remarks"
      />
    </td>
  </tr>
</template>
<script lang="ts">
import { Prop, Options, Vue, Watch } from "vue-property-decorator";
import { EntityClaimDet } from "furukawa-common/src/common/entity/EntityClaimDet";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  CONST_OP_CLAIM_ROUDING,
  CONST_OP_TAXRATE,
} from "furukawa-common/src/common/constant/Constants";
import { CommonPrice4FU } from "furukawa-common/src/common/function/CommonPrice4FU";
import Mo_CurrencyInput from "@/components/molecules/Mo_CurrencyInput.vue";
import Encoding from "encoding-japanese";

@Options({
  components: {
    vSelect,
    Mo_CurrencyInput,
  },
})
export default class Mo_claimlist_row extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: EntityClaimDet;

  @Prop({ required: true })
  btnDisable: boolean;

  det_price: number | null = null;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  opTaxtate = CONST_OP_TAXRATE;
  opRouding = CONST_OP_CLAIM_ROUDING;
  //----------------------
  //モーダル用プロパティ
  //----------------------

  async changeDetPrice() {
    if (this.det_price != null) {
      this.item.c_claim_det_price = this.det_price.toString();
    } else {
      this.item.c_claim_det_price = "";
    }
    this.calcTax();
  }

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    if (this.item.c_claim_det_price != null) {
      this.det_price = Number(this.item.c_claim_det_price!.replace(/,/g, ""));
    }
    // #6600 金額合計が計算されない不具合の修正
    this.eventCalc();
  }
  /**
   * 再計算イベントが発生した事を上位のコンポーネントに伝えるイベント発生
   */
  @Watch("item.c_claim_det_price_sum")
  eventCalc() {
    //再計算イベント発生
    //-----------------------
    this.$emit("reCalc");
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 品名の文字数オーバーを判定
   */
  isOverLength() {
    if (this.item.c_claim_det_item == null) {
      return false;
    }

    let count = 0;
    const str = this.item.c_claim_det_item;

    return this.getShiftJISByteLength(str) > 46;
  }
  getShiftJISByteLength(str: string): number {
    const sjisArray = Encoding.convert(str, {
      to: "SJIS",
      from: "UNICODE",
      type: "array",
    });
    return sjisArray.length;
  }

  /**
   * 金額セル入力時の処理
   * カンマを消す
   * @param obj
   */
  kanmaDel(obj: any) {
    // //カンマを消す
    obj.target.value = obj.target.value.replace(/,/g, "");
    if (obj.target.value == "0") obj.target.value = "";
  }
  /**
   * 金額セル入力時の処理
   * カンマを付ける
   * @param obj
   */
  kanmaIns(obj: any) {
    let val: string = obj.target.value;

    //うっかり入力しているかもしれないカンマを消す
    val = val.replace(/,/g, "");
    //整数に変換したのち文字列に戻す
    //この時点で数字とマイナス記号だけが残る
    let num = "" + parseInt(val);
    //正規表現で桁区切りするための良く見かける関数的な何か
    //変数 num の中身が、桁区切りされる
    while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    //numに入っている値が数値じゃないときは空白とする
    if (isNaN(parseInt(num))) num = "";
    //桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
    obj.target.value = num;
  }
  /**
   * 税込み金額計算
   */
  calcTax() {
    //開始判定
    //-------------
    if (
      // this.item.c_claim_det_taxrate == null ||
      // this.item.c_claim_det_taxrate == 0 ||
      this.item.c_claim_det_price == null ||
      this.item.c_claim_det_price == "" ||
      this.item.c_claim_det_price == "0"
    ) {
      this.item.c_claim_det_price_sum = "0";
      return;
    }

    //計算開始
    //-------------
    let sum = 0;
    let sum_str = this.item.c_claim_det_price;

    //税込金額計算
    //-------------

    //数字にパース
    sum_str = sum_str.replace(/,/g, "");
    sum = Number(sum_str);
    let sumTmp = "";

    switch (this.item.c_claim_det_taxrate) {
      //--MD参照前--------------------
      // case null:
      //   //消費税未設定：金額がそのまま税込み金額に入る
      //   sumTmp = sum.toString();
      //   while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
      //   this.item.c_claim_det_price_sum = sumTmp;
      //   break;
      // case 1:
      //   //5%
      //   sumTmp = Math.round((1 + 5 / 100) * sum).toString();
      //   while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
      //   this.item.c_claim_det_price_sum = sumTmp;
      //   break;
      // case 2:
      //   //8%
      //   sumTmp = Math.round((1 + 8 / 100) * sum).toString();
      //   while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));

      //   this.item.c_claim_det_price_sum = sumTmp;
      //   break;
      // case 3:
      //   //10%
      //   sumTmp = Math.round((1 + 10 / 100) * sum).toString();
      //   while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
      //   this.item.c_claim_det_price_sum = sumTmp;
      //   break;
      // case 4:
      //   //内税　ここでは金額がそのまま税込み金額に入る
      //   sumTmp = sum.toString();
      //   while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
      //   this.item.c_claim_det_price_sum = sumTmp;
      //   break;
      // default:
      //   //消費税未設定：金額がそのまま税込み金額に入る
      //   sumTmp = sum.toString();
      //   while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
      //   this.item.c_claim_det_price_sum = sumTmp;
      //   break;
      //----------------------
      //--MD参照後--------------------
      case null:
        //消費税未設定：金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(
          sum,
          this.item.c_claim_det_rounding!
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        this.item.c_claim_det_price_sum = sumTmp;
        break;
      case 1:
        //5%
        sumTmp = Math.round(
          CommonPrice4FU.cnvIntPrice(
            (1 + 5 / 100) * sum,
            this.item.c_claim_det_rounding!
          )
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        this.item.c_claim_det_price_sum = sumTmp;
        break;
      case 2:
        //8%
        sumTmp = Math.round(
          CommonPrice4FU.cnvIntPrice(
            (1 + 8 / 100) * sum,
            this.item.c_claim_det_rounding!
          )
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));

        this.item.c_claim_det_price_sum = sumTmp;
        break;
      case 3:
        //10%
        sumTmp = Math.round(
          CommonPrice4FU.cnvIntPrice(
            (1 + 10 / 100) * sum,
            this.item.c_claim_det_rounding!
          )
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        this.item.c_claim_det_price_sum = sumTmp;
        break;
      case 4:
        //内税　ここでは金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(
          sum,
          this.item.c_claim_det_rounding!
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        this.item.c_claim_det_price_sum = sumTmp;
        break;
      default:
        //消費税未設定：金額がそのまま税込み金額に入る
        sumTmp = CommonPrice4FU.cnvIntPrice(
          sum,
          this.item.c_claim_det_rounding!
        ).toString();
        while (sumTmp != (sumTmp = sumTmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
        this.item.c_claim_det_price_sum = sumTmp;
        break;
    }
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
td {
  border-left: 1px solid #dfdfdf;
}
.cwC_6 {
  border-right: 1px solid #dfdfdf;
}
.claimCont > input,
.claimCont > select {
  width: 100%;
  height: 30px;
  border: none;
}

.cwC_1 {
  width: 580px;
}
.cwC_2 {
  width: 80px;
}
.cwC_25 {
  width: 80px;
}
.cwC_3 {
  width: 150px;
}
.cwC_4 {
  width: 150px;
}
.cwC_5 {
  width: 120px;
}
.cwC_6 {
  width: 150px;
}
.cwC_7 {
  width: 125px;
}
.cwC_8 {
  width: 150px;
}

/* //------- */

.overLengthFrame,
.overLength {
  background-color: rgb(252, 194, 200);
}
.overLengthIcon {
  display: inline !important;
}

/* //------- */
input:disabled:not([type="button"]),
textarea:disabled {
  background-color: #fff;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

input[type="button"]:disabled {
  color: #444;
  background-color: #f4f4f4;
  border-color: #f4f4f4;
}
</style>
